import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  mainPageContainer: {
    display: 'flex',
  },

  container: {
    width: '100%',

    [theme.breakpoints.up('md')]: {
      flexGrow: 1,
      paddingLeft: '25px',
      width: '70%', // set width w.r.t the filterContainer width
    },

    [theme.breakpoints.up('lg')]: {
      maxWidth: '1440px',
    },

    [theme.breakpoints.up('xl')]: {
      width: '75%', // set width w.r.t the filterContainer width
    },
  },

  filterContainer: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'block',
      width: '30%',
      //backgroundColor: theme.palette.offWhite.main,
    },
    [theme.breakpoints.up('xl')]: {
      width: '25%',
    },
  },

  headerContainer: {
    padding: '0 25px',
    position: 'sticky',
    zIndex: '9',
    display: 'flex',
    alignItems: 'flex-start',
    columnGap: '25px',
    backgroundColor: theme.palette.whitePepper.main,

    [theme.breakpoints.up('md')]: {
      padding: '15px 50px 0 0',
    },
  },

  headerTitleWrapper: {
    paddingBottom: '25px',
    flexGrow: 1,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    columnGap: '25px',
    overflowX: 'auto',

    // to not display scroll bar
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '-ms-overflow-style': 'none' /* IE and Edge */,
    scrollbarWidth: 'none' /* Firefox */,
  },

  panelcontentWrapper: {
    padding: '0 25px',
    [theme.breakpoints.up('sm')]: {
      padding: '0 50px',
    },
    [theme.breakpoints.up('md')]: {
      padding: '0',
    },
  },

  filterListWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    columnGap: '10px',
    rowGap: '10px',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },

  filterList: {
    width: 'max-content',
    backgroundColor: theme.palette.whitePepper.main,
    borderRadius: '24px',
    padding: '10px 18px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    columnGap: '5px',
  },

  loader: {
    animation: `$spin 2s linear infinite`,
  },
  '@keyframes spin': {
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(-360deg)' },
  },

  backToTopBtnWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginBottom: '75px',
    cursor: 'pointer',
    paddingRight: '25px',

    [theme.breakpoints.down('md')]: {
      marginBottom: '100px',
    },
  },
});
